import TabbedDialog from 'global/guides/Dialog/TabbedDialog'
import { hasPermission } from 'hooks/useBackendMenu'
import { useRegrasCalculoContext } from 'pages/RegrasCalculo'
import { useParams } from 'react-router-dom'
import { regrasCalculo, updateRegrasCalculoSchema } from 'service/api'
import { toast } from 'sonner'
import {
    TabGeral,
    TabHorasExtras,
    TabHoristaEFaltas,
    TabNoturno,
} from '../forms/FormRegraCalculo'

const TABS = [
    { name: 'geral', label: 'Geral', content: <TabGeral /> },
    { name: 'horasExtras', label: 'Horas Extras', content: <TabHorasExtras /> },
    { name: 'noturno', label: 'Noturno', content: <TabNoturno /> },
    {
        name: 'horista',
        label: 'Horista e Faltas',
        content: <TabHoristaEFaltas />,
    },
]

export default function EditarRegraCalculoPage() {
    const { regrasCalculoId } = useParams()
    const { data } = useRegrasCalculoContext()
    const { mutateAsync, isLoading } = regrasCalculo.mutations.useUpdate({
        invalidateQuery: true,
        onSuccess: () => {
            toast.success('Regra de cálculo editada com sucesso')
        },
        onError: e => {
            toast.error(e.message)
        },
    })

    const row = data?.find(item => item.id === Number(regrasCalculoId))
    if (!row) return null

    return (
        <TabbedDialog.Root
            tabs={TABS}
            open={hasPermission(['update', 'RegrasDeCálculo'])}
            onSubmit={values => mutateAsync({ ...values, id: row.id })}
            loading={isLoading}
            width="62rem"
            schema={updateRegrasCalculoSchema}
            defaultValues={row}
        >
            <TabbedDialog.Title>Editar regra de cálculo</TabbedDialog.Title>
            <TabbedDialog.Content dividers />
            <TabbedDialog.Actions>
                <TabbedDialog.Actions.SecondaryButton />
                <TabbedDialog.Actions.PrimaryButton closeOnSubmit />
            </TabbedDialog.Actions>
        </TabbedDialog.Root>
    )
}
